import baseService from './baseService.js';

export function getActivityList(params) {
  return baseService.get('/applicants/activities', { params });
}

export function getLeaderBoardList(params) {
  return baseService.get('/applicants/leaderboard', { params });
}

export function likeActivity(activityId) {
  return baseService.post(`/applicants/activities/${activityId}/like`);
}

export function unlikeActivity(activityId) {
  return baseService.post(`/applicants/activities/${activityId}/unlike`);
}

export function getTermsAndConditions(organizationId) {
  return baseService.get(`/organizations/${organizationId}/term_and_conditions`);
}

export function getHotJobs(params) {
  return baseService.get('/organizations/hot_jobs', { params });
}

export function getRecommendedJobs(params) {
  return baseService.get('/organizations/job_recommendations', { params });
}

export function getReferralRecommendations(params) {
  return baseService.get('/member/referral_matches', {
    params: { limit: params.limit, offset: params.offset, per_contact: params.per_contact, include_reasons: true },
  });
}

export function getReferralLink(data) {
  return baseService.post('/referral_links', data);
}
